import { Operation } from "@/backend/models/operation";
import { useGetAllInputParametersForOperation } from "@/frontend/hooks/parameters";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { parseReferences, resize } from "@/frontend/utils/parseReferences";
import { I18n } from "@/i18n/I18n";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

export function TextInput(props: { operation: Operation, textClassname?: string }) {
  const { operation, textClassname } = props;
  const parameters = useGetAllInputParametersForOperation(operation);
  const updateOperation = useTreeStore(state => state.updateOperation);
  const textClass = textClassname || 'form-control form-control-sm';
  const [contentValue, setContentValue] = useState(operation.content);

  const [error, setError] = useState('');

  useEffect(() => {
    const parseRefsError = parseReferences(operation.content, parameters);
    if (parseRefsError) {
      setError(parseRefsError);
    }
  }, [operation.content, parameters]);

  const setContentWrapper = (value: string) => {
    setContentValue(value);
    setError('');
    const parseRefsError = parseReferences(value, parameters);
    if (parseRefsError) {
      setError(parseRefsError);
    }
    resize(`content-${operation.id}`);
  };

  useEffect(() => {
    resize(`content-${operation.id}`);
  }, [operation.id]);

  useEffect(() => {
    setContentValue(operation.content);
  }, [operation.content]);

  return (
    <div className="justify-content-center">
      <Form.Label className="col-form-label col-form-label-sm">{I18n.get('content')}</Form.Label>
      <div className="w-100">
          <textarea
            className={textClass}
            id={`content-${operation.id}`}
            onChange={(e) => setContentWrapper(e.target.value)}
            value={contentValue}
            name='text-content'
            onBlur={() => void updateOperation({ operation: { ...operation, content: contentValue } })}
          />
        <p className='text-danger col-12'>{error}</p>
     </div>
    </div>
  );
}
